module.exports = __webpack_public_path__ + "img/4-1_02.7061b01b.jpg";